import { createEvent, createStore, sample } from 'effector'
import { goodsFeaturesTemplates } from '@entities/goods-features/model'
import { mergeFavorites, pickupFavorite } from 'src/features/favorite/model/favorite-storage'
import { getCustomerProfile } from '@entities/customer/model'
import { pickupBasket, pickupBasketUpdate } from '@entities/basket/model'
import { allGroupsQuery } from '@entities/groups/model'
import { $cities, citiesQuery } from '@entities/cities/model'
import { stocksQuery } from '@entities/stocks/model'
import { pickupPagination } from 'src/widgets/pagination-goods/model'
import { filterListQuery } from 'src/features/filter-goods/model/filter'
import { checkAuthorizationFx } from '@entities/authorization/model'
import { pickupPrescription } from '@entities/prescription/model'
import { once } from 'patronum'

export const onMountMainOnce = createEvent()
export const onMountMain = once(onMountMainOnce)

export const onUnmountMain = createEvent()

export const $isMounted = createStore<boolean>(false, { serialize: 'ignore' })

sample({
    clock: onMountMain,
    fn: () => true,
    target: $isMounted
})

sample({
    clock: onMountMain,
    target: goodsFeaturesTemplates.refresh
})

sample({
    clock: onMountMain,
    target: pickupFavorite
})

sample({
    clock: onMountMain,
    target: checkAuthorizationFx
})

sample({
    clock: onMountMain,
    target: mergeFavorites
})

sample({
    clock: onMountMain,
    target: getCustomerProfile
})

sample({
    clock: onMountMain,
    target: pickupBasketUpdate
})
sample({
    clock: onMountMain,
    target: allGroupsQuery.start
})

sample({
    clock: onMountMain,
    source: $cities,
    filter: (cities) => !cities || cities.length < 1,
    target: citiesQuery.start
})

sample({
    clock: onMountMain,
    target: stocksQuery.start
})

sample({
    clock: onMountMain,
    target: pickupPagination
})

sample({
    clock: onMountMain,
    target: filterListQuery.refresh
})

sample({
    clock: onMountMain,
    target: pickupBasket
})

sample({
    clock: onMountMain,
    target: pickupPrescription
})
